import * as React from "react";
const Root = "div";
interface Props {
  width: number;
  height: number;
  size: number;
  Component: React.ElementType;
}
const classes = {
  backdrop: "b1a0xzv7",
  grid: "g10obtzp"
};
function Canvas(props: Props) {
  const {
    width,
    height,
    size,
    Component
  } = props;
  return <Root className={"r1bcczis"} style={{
    width,
    height
  }}>
      <div className={classes.backdrop} />
      <Grid className={classes.grid} size={size} />
      <div style={{
      fontSize: `${size}px`,
      zIndex: 1
    }}>
        <Component />
      </div>
    </Root>;
}
export default Canvas;
function Grid({
  size,
  ...rest
}: {
  size: number;
} & React.ComponentProps<"svg">) {
  const halfSize = size / 2;
  const center = 60;
  const whiskerLength = Math.min(16, size / 2);
  const Corner = ({
    dx,
    dy
  }: {
    dx: (a: number, b: number) => number;
    dy: (a: number, b: number) => number;
  }) => <g>
      <line x1={dx(center, halfSize)} x2={dx(center, halfSize + whiskerLength)} y1={dy(center, halfSize)} y2={dy(center, halfSize)} strokeWidth={1} stroke="#EEEEEE" />
      <line x1={dx(center, halfSize)} x2={dx(center, halfSize)} y1={dy(center, halfSize)} y2={dy(center, halfSize + whiskerLength)} strokeWidth={1} stroke="#EEEEEE" />
    </g>;
  const add = (a: number, b: number): number => a + b;
  const sub = (a: number, b: number): number => a - b;
  return <svg width="120" height="120" viewBox="0 0 120 120" {...rest}>
      <rect x={center - halfSize} y={center - halfSize} width={size} height={size} fill="#FFBBFF88" />

      <Corner dx={sub} dy={sub} />
      <Corner dx={add} dy={sub} />
      <Corner dx={add} dy={add} />
      <Corner dx={sub} dy={add} />
    </svg>;
}

require("./Canvas.linaria.module.css!=!../../../../../node_modules/.pnpm/@linaria+webpack5-loader@5.0.4_webpack@5.91.0/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./Canvas.tsx");